"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var utils_1 = tslib_1.__importDefault(require("./utils"));
var getParent = utils_1.default.getParent;
function isAncestorFixed(element) {
    if (utils_1.default.isWindow(element) || element.nodeType === 9) {
        return false;
    }
    var doc = utils_1.default.getDocument(element);
    var body = doc.body;
    var parent = null;
    for (parent = getParent(element); parent && parent !== body; parent = getParent(parent)) {
        var positionStyle = utils_1.default.css(parent, 'position');
        if (positionStyle === 'fixed') {
            return true;
        }
    }
    return false;
}
exports.default = isAncestorFixed;
//# sourceMappingURL=isAncestorFixed.js.map